import { InputRadioFreeComponent } from './input-radio-free.component';

export default angular
  .module('sfMobile.components.input-radio-free', [
    'sfMobile.services.popup',
    'sfMobile.components.input-radio',
  ])
  .component('sfInputRadioFree', InputRadioFreeComponent).name;
